export default __webpack_public_path__ + "static/media/sc.f78b46ab.svg";